import React, { useEffect, useState } from "react";
import headerLayoutWrapper from "../../hoc/headerLayoutWrapper";
import { getUserById } from "../../services/services";
import Loading from "../../components/loading";
import { toast } from "react-toastify";
import { updateUser } from "../../services/services";

import {
  User,
  Phone,
  Mail,
  Calendar,
  BadgeCheck,
  CreditCard,
  Building2,
} from "lucide-react";
import moment from "moment";
import { useNavigate } from "react-router";

const Account = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const fetchUser = async () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("Login_User"));
      const userId = storedUser?._id;

      if (!userId) return toast.error("User ID not found");

      const response = await getUserById(userId);
      if (response.data.status) {
        setUser(response.data.response);
      }
    } catch (err) {
      console.error("Failed to fetch user:", err);
      toast.error(err.message || "Failed to load account details");
    } finally {
      setLoading(false);
    }
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
      });
    }
  }, [user]);

  const handleUpdate = async () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("Login_User"));
      const userId = storedUser?._id;

      const res = await updateUser(userId, formData);

      if (res.data.status) {
        toast.success(res.data.message);

        setUser(res.data.response.user || res.data.response);

        if (res.data.response.token) {
          localStorage.setItem("token", res.data.response.token);
        }

        setIsEdit(false);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Update failed");
    }
  };
  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div id="main">
          <h4 className="mb-4 custom-title">Account Details</h4>
          <div className="row g-4">
            {/* USER INFO */}
            <div className="col-lg-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-muted">User Information</h6>

                    {!isEdit ? (
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setIsEdit(true)}
                      >
                        Edit
                      </button>
                    ) : (
                      <div>
                        <button
                          className="btn btn-sm btn-success me-2"
                          onClick={handleUpdate}
                        >
                          Save
                        </button>
                        <button
                          className="btn btn-sm btn-secondary"
                          onClick={() => {
                            setIsEdit(false);
                            setFormData({
                              name: user.name,
                              email: user.email,
                              phone: user.phone,
                            });
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    )}
                  </div>

                  <hr className="my-2" />

                  {/* NAME */}
                  <InfoRow
                    icon={<User size={18} />}
                    label="Name"
                    value={
                      isEdit ? (
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={(e) =>
                            setFormData({ ...formData, name: e.target.value })
                          }
                          className="form-control form-control-sm"
                        />
                      ) : (
                        user?.name
                      )
                    }
                  />

                  {/* EMAIL */}
                  <InfoRow
                    icon={<Mail size={18} />}
                    label="Email"
                    value={
                      isEdit ? (
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                          className="form-control form-control-sm"
                        />
                      ) : (
                        user?.email
                      )
                    }
                  />

                  {/* PHONE */}
                  <InfoRow
                    icon={<Phone size={18} />}
                    label="Phone"
                    value={
                      isEdit ? (
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={(e) =>
                            setFormData({ ...formData, phone: e.target.value })
                          }
                          className="form-control form-control-sm"
                        />
                      ) : (
                        user?.phone
                      )
                    }
                  />

                  {/* JOIN DATE */}
                  <InfoRow
                    icon={<Calendar size={18} />}
                    label="Joined On"
                    value={moment(user?.createdAt).format("DD MMM, YYYY")}
                  />
                </div>
              </div>
            </div>

            {/* PLAN INFO */}
            <div className="col-lg-6">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex  justify-content-between mb-3">
                    <h6 className="mb-0 text-muted">Subscription Plan</h6>

                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => navigate("/pricing")}
                    >
                      Upgrade / Renew plan
                    </button>
                  </div>

                  <hr className="my-2 " />

                  <InfoRow
                    icon={<CreditCard size={18} />}
                    label="Plan Type"
                    value={
                      <span
                        className="badge bg-primary"
                        // style={{ backgroundColor: "#0B2B6D", color: "#FFFFFF" }}
                      >
                        {/* {user?.plan.type}  */}
                        {user?.plan?.type || "Free"}
                      </span>
                    }
                  />
                  <InfoRow
                    icon={<CreditCard size={18} />}
                    label="Amount"
                    // value={`₹ ${user?.plan.amount}`}
                    value={
                      user?.plan?.amount === 0 || user?.plan?.amount == null
                        ? "Free"
                        : `₹ ${user.plan.amount}`
                    }
                  />
                  <InfoRow
                    icon={<Calendar size={18} />}
                    label="Billing Cycle"
                    // value={user?.plan.billing_cycle}
                    value={user?.plan?.billing_cycle || "Free Plan"}
                  />
                  <InfoRow
                    icon={<Calendar size={18} />}
                    label="Subscribed On"
                    value={moment(user?.plan.subscribed_date).format(
                      "DD MMM, YYYY",
                    )}
                  />
                  <InfoRow
                    icon={<Calendar size={18} />}
                    label="Expiry Date"
                    value={moment(user?.plan.expiry_date).format(
                      "DD MMM, YYYY",
                    )}
                  />
                </div>
              </div>
            </div>

            {/* BUSINESS INFO */}
            {/* <div className="col-12">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h6 className="mb-3 text-muted">Business Information</h6>

                  <InfoRow
                    icon={<Building2 size={18} />}
                    label="Active Business ID"
                    value={user?.activeBusiness}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

const InfoRow = ({ icon, label, value }) => (
  <div className="d-flex mb-3">
    <div className="me-3 " style={{ color: "#0b2b6d" }}>
      {icon}
    </div>
    <div className="flex-grow-1">
      <div className="small text-muted">{label}</div>
      <div className=" text-break" style={{ fontSize: "14px" }}>
        {value}
      </div>
    </div>
  </div>
);

export default headerLayoutWrapper(Account);
